module.exports = __webpack_public_path__ + "static/img/bg-ar.2c8d4764.png";